import { Repository } from '../servics/httpsServics';

// Get all available projects
export function getAllProjects(interpreterId) {
  if (interpreterId) {
    return Repository.get(`/stai2/projects?interpreter=${interpreterId}`);
  } else {
    return Repository.get('/stai2/projects');
  }
}

export function getProjectById(id) {
  return Repository.get(`/stai2/projects/${id}`);
}
